import { useEffect, useState } from 'react';
import { api, Dashboard } from '../api/client';
import { DashboardCard, SkeletonCard } from '../components/Layout';
import { CATEGORIES, resolveCategory } from '../lib/categories';

export default function SharedPage() {
  const [dashboards, setDashboards] = useState<Dashboard[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listShared()
      .then((r) => setDashboards(r.dashboards ?? []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>Shared with Me</h1>

      {loading && (
        <div className="grid">
          {Array.from({ length: 4 }, (_, i) => <SkeletonCard key={i} />)}
        </div>
      )}

      {!loading && !dashboards.length && (
        <p className="muted">Nothing shared with you yet.</p>
      )}

      {!loading && CATEGORIES.map((cat) => {
        const group = dashboards.filter((d) => resolveCategory(d) === cat.key);
        if (!group.length) return null;
        return (
          <section key={cat.key} className="upload-section">
            <h2 className="upload-section-title">{cat.section}</h2>
            <div className="grid">
              {group.map((d) => <DashboardCard key={d.dashboardId} dashboard={d} />)}
            </div>
          </section>
        );
      })}
    </div>
  );
}
